import * as constants from 'helper/constants';
import React, { PureComponent } from 'react';
import { Redirect } from 'react-router-dom';
import strings from 'helper/localization/localization';

export default class ForgotPassword extends PureComponent {
  constructor(props) {
    super(props);

    // State
    this.state = {
      resetPasswordRequestSent: false,
      formError: false,
      loading: false,
    };

    // Properties
    this.api = this.props.api;
    this.formAttributes = {
      email: '',
    };

    // Bindings
    this.emailChanged = this.emailChanged.bind(this);
    this.resetPasswordRequest = this.resetPasswordRequest.bind(this);
  }

  emailChanged(event) {
    this.formAttributes.email = event.target.value;
  }

  resetPasswordRequest(e) {
    e.preventDefault();
    this.setState({
      formError: false,
      loading: true,
    });

    const email = this.formAttributes.email;

    this.api.resetPasswordRequest(email, (api) => {
      if (api.status === constants.api.success) {
        this.setState({
          resetPasswordRequestSent: true,
          loading: false,
        });
      } else {
        this.setState({
          formError: true,
          loading: false,
        });
      }
    });
  }

  render() {
    if (this.state.resetPasswordRequestSent) {
      return (<Redirect
        push
        to={{
          pathname: '/login',
          state: { successAlert: strings.resetPasswordRequestSent },
        }}
      />);
    }

    const errorAlert = this.state.formError ?
      (
        <div className="alert alert-danger alert-dismissible fade show" role="alert">
          {strings.forgotPasswordFormError}
          <button type="button" className="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">{'\u00D7'}</span>
          </button>
        </div>
      ) : null;


    return (
      <div className="container">
        { errorAlert }
        <div className="row">
          <div className="col">
            <h1>{strings.forgottenYourPassword}</h1>
          </div>
        </div>

        <div className="row">
          <div className="col">
            <p>{strings.forgotPasswordForm}</p>
          </div>
        </div>

        <form className={`form-default ${this.state.loading ? 'disabled' : ''}`}>
          <div className="form-group">
            <label htmlFor="forgot-password--email">{strings.emailAddress}</label>
            <input type="email" className="form-control" onChange={this.emailChanged} id="forgot-password--email" />
          </div>
          <button
            type="submit"
            className="btn btn-outline-primary btn-lg btn-block"
            id="button--forgot-password"
            onClick={this.resetPasswordRequest}
          >
            {strings.resetPassword}
          </button>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/login/ForgotPassword.jsx